import { RootState } from "store/reducers";

export const selectSSEClientId = (store: RootState) =>
  store.sse.clientId
